import { useEffect, useRef, useState } from 'react';
import Card from '../../../components/Card/Card';
import List from '../../../components/List/List';
import Pagination from '../../../components/Pagination/Pagination';
import ReaderService from '../../../services/ReadersService';
import './ListReaders.css';
import { useAuth } from '../../../contexts/auth';
import { useUserStore } from '../../../contexts/userStore';
import { TiArrowLeftThick, TiArrowRightThick } from 'react-icons/ti';
import { getReaderModelByEnum } from '../../../constants/readers-model';
import { useSSEContext } from '../../../contexts/sse';
import Button from '../../../components/Button/Button';
import { FaRegHandshake } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import MqttService from '../../../services/MqttService';
import { SendAdjustButton } from './SendAdjustButton';

export function ListReaders(props) {
   const [readers, setReaders] = useState([]);
   const [maxPage, setMaxPage] = useState(1);
   const [collumnClicked, setCollumnClicked] = useState({
      collumnTitle: "updatedAt",
      orderDirection: "DESC",
   });
   const { user, can } = useAuth();
   const { selectedCondominio } = useUserStore();
   const { sseReceived } = useSSEContext();
   const [currentPage, setCurrentPage] = useState(1);
   const [isLoading, setIsLoading] = useState(true);
   const cancelTokenRef = useRef(null);
   const { t } = useTranslation();

   const getReaders = async (page, searchText, condominiumId, orderBy) => {
      try {
         if (cancelTokenRef.current) {
            cancelTokenRef.current.abort();
         }
         cancelTokenRef.current = new AbortController();
         setIsLoading(true);
         const response = await ReaderService.getPaginatedReaders(
            page,
            searchText,
            '',
            condominiumId,
            orderBy,
            cancelTokenRef.current.signal
         );
         setIsLoading(false);
         if (response && response.data) {
            const paginated = response.data;
            const formattedReaders = paginated.items ?? [];
            setReaders(formattedReaders);
            setMaxPage(paginated.totalPages);
         }
         setCurrentPage(page);
      } catch (error) {
         console.error(error);
      }
   };

   useEffect(() => {
      getReaders(currentPage, props.filters, selectedCondominio, collumnClicked);
   }, [
      user,
      props.filters,
      collumnClicked,
      selectedCondominio,
      props.refreshKey,
      currentPage
   ]);

   useEffect(() => {
      if (sseReceived?.action === "replyReaderReceived") {
         getReaders(
            currentPage,
            props.filters,
            selectedCondominio,
            collumnClicked
         );
      }
   }, [
      sseReceived,
   ]);

   return (
      <>
         <div className="list-container list-visibility">
            <List
               isLoading={isLoading}
               listEntityName="readers"
               lineSelected={props.lineSelected}
               handleCollumnTitleClick={(col) => setCollumnClicked(col)}
               collumsObjIndex={[
                  { collumnLabel: t("common.name"), index: "name", type: "text" },
                  {
                     collumnLabel: t("common.direction"), index: "direction", type: "custom", custom: ({ row }) => (
                        <span className='flex items-center flex-row gap-1'>
                           {row.direction === 0 && (
                              <span className="entry">
                                 <TiArrowRightThick />
                              </span>
                           )}
                           {row.direction === 1 && (
                              <span className="exit">
                                 <TiArrowLeftThick />
                              </span>
                           )}
                           {row.direction === 1 ? t("common.exit") : t("common.entry")}
                        </span>
                     )
                  },
                  { collumnLabel: t("common.type"), index: "model", type: "text", custom: ({ row }) => getReaderModelByEnum(row.model)?.name },
                  {
                     collumnLabel: t("common.enabled"),
                     index: "enabled",
                     type: "enabled",
                  },
                  { collumnLabel: t("common.status"), index: "status", type: "sync-status" },
                  {
                     collumnLabel: t("common.actions"),
                     index: "actions",
                     type: "actions",
                     custom: ({ row }) => can?.("bravas.accessControl.reader.adjust") ? (
                        <SendAdjustButton reader={row} />
                     ) : (
                        <></>
                     )
                  }
               ]}
               data={readers}
            />
         </div>
         <div className="card-visibility">
            {readers.map((reader, index) => (
               <Card
                  key={reader.id || index}
                  data={reader}
                  delete={() => { }}
                  navigateOnDelete={""}
                  navigateOnEdit={""}
               >
                  <p className="card-content-title">{reader.name}</p>
               </Card>
            ))}
         </div>
         <Pagination
            rowsPerPage={8}
            maxPage={maxPage}
            changePage={(page) =>
               setCurrentPage(page)
            }
         />
      </>
   );
}